export default "__VITE_ASSET__CKkzUsZP__"